import React from 'react'
import { createRoot } from 'react-dom/client'
import NavigationSearch from './NavigationSearch.jsx'

const elmentName = 'navigation-search'
customElements.get(elmentName) ||
  (function () {
    class NavigationSearchElement extends HTMLElement {
      connectedCallback() {
        const action = this.dataset?.action
        const name = this.dataset?.name
        const isMobile = this.dataset?.mobile === 'true' ? true : false
        if (action) {
          const reactContainerClassName = elmentName
          const reactContainer = document.createElement('div')
          reactContainer.setAttribute('class', reactContainerClassName)
          this.appendChild(reactContainer)

          const root = createRoot(reactContainer)

          root.render(
            <NavigationSearch
              {...{
                action,
                name,
                isMobile,
              }}
            />
          )
        }
      }
    }

    customElements.define(elmentName, NavigationSearchElement)
  })()
